import { useState, useEffect } from 'react';
import api from '../../schedulerApi';

const useGetAllDeviceDailyConfigs = (deviceId, weeklyBp = null, dailyBp = null) => {
    const [configsByDayId, setConfigsByDayId] = useState({});
    const [isReady, setIsReady] = useState(false);

    const weeklyKey = weeklyBp
        ? Object.values(weeklyBp)
              .filter(bp => bp?.id)
              .map(bp => bp.id)
              .sort()
              .join(',')
        : '';

    const dailyKey = dailyBp?.id ?? '';

    useEffect(() => {
        const fetchAll = async () => {
            if (!deviceId) {
                setIsReady(true);
                return;
            }

            if (!weeklyKey && !dailyKey) {
                setConfigsByDayId({});
                setIsReady(true);
                return;
            }

            const bpList = weeklyKey ? weeklyKey.split(',').map(id => ({ id })) : [{ id: dailyBp.id }];

            const result = {};

            await Promise.all(
                bpList.map(async ({ id }) => {
                    try {
                        const cfg = await api.get_device_daily_bp_configs(deviceId, id);
                        result[id] = cfg ?? [];
                    } catch (err) {
                        console.warn(`Failed fetching configs for bp ${id}`, err);
                        result[id] = [];
                    }
                })
            );

            setConfigsByDayId(result);
            setIsReady(true);
        };

        fetchAll();
    }, [deviceId, weeklyKey, dailyKey]);

    const refetch = async () => {
        setIsReady(false);
        const bpIds = weeklyKey ? weeklyKey.split(',').map(id => ({ id })) : dailyKey ? [{ id: dailyBp.id }] : [];

        const result = {};
        await Promise.all(
            bpIds.map(async ({ id }) => {
                try {
                    const cfg = await api.get_device_daily_bp_configs(deviceId, id);
                    result[id] = cfg ?? [];
                } catch {
                    result[id] = [];
                }
            })
        );
        setConfigsByDayId(result);
        setIsReady(true);
    };

    return { configsByDayId, isReady, refetch };
};

export default useGetAllDeviceDailyConfigs;
